import { generatePopup } from "../../utility/popup";
import * as actionTypes from "../ActionTypes";
import { apiDelete, apiGet, apiPost, apiPut } from "../axios";

export const getVendors = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_VENDORS_INIT,
    });

    try {
      const response = await apiGet(
        `getvendor?page=${payload?.page}&limit=${payload?.limit}&search=${
          payload?.search ? payload?.search : ""
        }`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_VENDORS_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_VENDORS_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const AddVendor = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_VENDORS_INIT,
    });

    try {
      const response = await apiPost("addvendor", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.ADD_VENDORS_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.ADD_VENDORS_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.ADD_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.ADD_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.ADD_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const DeleteVendor = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_VENDORS_INIT,
    });

    try {
      const response = await apiDelete(`vendordelete/${payload}`, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.DELETE_STORE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.DELETE_VENDORS_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.DELETE_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.DELETE_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const UpdateVendor = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_VENDORS_INIT,
    });

    try {
      const response = await apiPut(
        `vendorup/${payload.id}`,
        payload.data,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_VENDORS_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.UPDATE_VENDORS_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.UPDATE_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.UPDATE_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_VENDORS_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};
